import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
import { Menu24 } from '@carbon/icons-react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
var internalTopItemClassName = "z-[110] w-10 h-10 relative rounded-default\n    cursor-pointer text-valhalla mr-2 hover:bg-hover-grey\n    [&>svg]:absolute [&>svg]:top-2/4 [&>svg]:left-2/4\n    [&>svg]:-translate-x-2/4 [&>svg]:-translate-y-2/4\n    [&>svg]:w-6 [&>svg]:h-6";
export var topItemClassName = twMerge("hidden sm:".concat(internalTopItemClassName, " sm:inline-block"));
export var GlobalMenu = function (_a) {
    var logoPath = _a.logoPath, isAuthenticated = _a.isAuthenticated, openSidebarOnMobile = _a.openSidebarOnMobile, _b = _a.logoProps, logoProps = _b === void 0 ? {
        src: 'https://cdn.mercell.com/logos/Mercell_Logo_rgb_dark.svg',
        alt: 'Mercell-logo',
        width: '152px',
        height: '40px',
    } : _b, _c = _a.trackingAction, trackingAction = _c === void 0 ? function (_trackingEventType, _trackingProperties, defaultAction) {
        return function (e) {
            return defaultAction(e);
        };
    } : _c, _d = _a.additionalTrackingParams, additionalTrackingParams = _d === void 0 ? {} : _d, className = _a.className, children = _a.children;
    var headerRef = useRef(null);
    useEffect(function () {
        document.addEventListener('scroll', debounce(storeScroll, headerRef), {
            passive: true,
        });
        storeScroll(headerRef);
        return function () {
            document.removeEventListener('scroll', debounce(storeScroll, headerRef));
        };
    }, []);
    return (React.createElement("header", { ref: headerRef, className: twMerge('row-span-1 col-start-2 col-end-3 grid-c bg-transparent h-[98px] sticky top-0 z-[100] data-[scroll=true]:bg-white data-[scroll=true]:shadow-[0px_1px_4px_rgba(114,114,114,0.15)]', className) },
        React.createElement("div", { className: "flex justify-between items-center pt-6 px-4 xl:px-8 2xl:px-16" },
            React.createElement("div", { className: "flex" },
                isAuthenticated && openSidebarOnMobile && (React.createElement("button", { type: "button", className: "".concat(internalTopItemClassName, "\n                            xl:hidden ignore-outside-click"), onClick: function () { return openSidebarOnMobile(true); } },
                    React.createElement(Menu24, null))),
                React.createElement(NavLink, { to: isAuthenticated ? logoPath : '', className: cx('self-center', isAuthenticated ? 'cursor-pointer' : 'cursor-auto'), onClick: trackingAction('click', __assign(__assign({}, additionalTrackingParams), { ep_component_link_url: "".concat(window.location.origin).concat(logoPath), ep_component_name: 'mercell_logo', ep_component_action_context: 'mercell_logo' })) },
                    React.createElement("img", __assign({}, logoProps, { alt: logoProps.alt })))),
            React.createElement("div", { className: "flex items-center" }, children))));
};
export default GlobalMenu;
var debounce = function (fn, headerRef) {
    var frame;
    return function () {
        if (frame) {
            cancelAnimationFrame(frame);
        }
        frame = requestAnimationFrame(function () {
            fn(headerRef);
        });
    };
};
var storeScroll = function (headerRef) {
    var element = headerRef.current;
    if (!element)
        return;
    if (window.scrollY > 0) {
        element.dataset.scroll = 'true';
    }
    else {
        element.dataset.scroll = 'false';
    }
};
